<template>
  <div class="loan-list">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="操作系统说明书"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!--贷款详情-->
    <div>
      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>一、账号开通</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>系统使用人员需联系网络管理员开通账号，账号开通后，可通过关注 “宝通家族” 公众号进入招商报备系统进行操作。</span>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>二、系统使用步骤</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <span>
              （一）客户报备<br>
登录系统：进入 “宝通家族” 公众号，点击相关入口，使用已开通的账号登录招商报备系统。
            </span>
            <span>
              <br>
              <br>
              提交报备：登录成功后，在系统内找到客户报备功能模块，按页面提示填写自己招商客户的相关信息，完成后提交报备。
            </span>
            <span>
              <br>
              <br>
              冲突提示：若您提交报备的客户已被其他用户报备，系统将弹出提示，明确告知该客户已被他人报备，此时您无法重复报备此客户。
            </span>
            <span>
              <br>
              <br>
              （二）客户查询<br>
            在系统中找到客户查询功能模块，通过该模块可查看所有系统用户报备的客户数量及相关信息，便于了解招商报备整体情况。
            </span>
            <span>
              <br>
              <br>
              （三）个人中心管理<br>
            进入个人中心，可查看自己已报备的所有客户信息及数量统计，方便对个人招商报备工作进行管理和梳理。
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
    'name': 'LoanList',
    data() {
        return {

        };
    },
    computed: {

    },
    methods: {
      onClickLeft() {
          this.$router.push({path: '/home'});
      }
    },
    mounted() {

    },
    beforeCreate() {

    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.loan-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.loan-list >>> .van-nav-bar__text {
  color: #fff;
}
.loan-list >>> .van-nav-bar__title {
  color: #fff;
}
.loan-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.loan-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}
</style>
